export const USD_DISCLAIMER = 'All values in USD equivalent.'
export const NO_POSITIONS_TO_DISPLAY = 'There are no positions to display.'
